<template>
  <div class="medication-request-patient-info">
    <form-group
      :errors="errors"
      :required="true"
      error-key="subject.id"
      for-id="patient-id"
      label="Run">
      <app-rut-input
        id="patient-id"
        type="text"
        class="form-control"
        :value="subject.id"
        @input="handlePatientUpdate('id', $event)"
        @blur="handlePatientIdInputBlur" />
    </form-group>
    <form-group
      v-loading="fetchingSubjectInformation"
      :errors="errors"
      error-key="subject.display"
      for-id="patient-given-name"
      label="Nombre">
      <input
        id="patient-given-name"
        type="text"
        class="form-control"
        :value="subject.name.given"
        readonly="readonly"
        @input="handlePatientUpdate('name.given', $event)">
    </form-group>
    <form-group
      v-loading="fetchingSubjectInformation"
      for-id="patient-family-name"
      label="Apellidos">
      <input
        id="patient-family-name"
        type="text"
        class="form-control"
        :value="subject.name.family"
        readonly="readonly"
        @input="handlePatientUpdate('name.family', $event)">
    </form-group>
    <div v-if="requiresLegalRepresentative" class="row">
      <div class="col-12">
        <div class="alert alert-warning">
          <i class="fas fa-exclamation-circle"></i> Al ser un menor de edad, por favor ingrese datos de su representante legal
        </div>
        Representante Legal
        <hr>
        <form-group
          :errors="errors"
          :required="true"
          error-key="subject.contact[0].id"
          for-id="contact-id"
          label="Rut">
          <app-rut-input
            id="contact-id"
            type="text"
            class="form-control"
            :value="subject.contact[0].id"
            @input="handlePatientUpdate('contact[0].id', $event)"
            @blur="handleContactIdInputBlur" />
        </form-group>
        <form-group
          v-loading="fetchingContactSubjectInformation"
          :errors="errors"
          error-key="subject.contact[0].name.given"
          for-id="contact-given-name"
          label="Nombre">
          <input
            id="contact-given-name"
            type="text"
            class="form-control"
            readonly="readonly"
            :value="subject.contact[0].name.given"
            @input="handlePatientUpdate('contact[0].name.given', $event)">
        </form-group>
        <form-group
          v-loading="fetchingContactSubjectInformation"
          for-id="contact-family-name"
          label="Apellidos">
          <input
            id="contact-family-name"
            :value="subject.contact[0].name.family"
            type="text"
            class="form-control"
            readonly="readonly"
            @input="handlePatientUpdate('contact[0].name.family', $event)">
        </form-group>
      </div>
    </div>
    <address-input
      :value="subject.address"
      :errors="errors"
      errors-prefix="subject"
      @input="handlePatientUpdate('address', $event)" />

    <form-group
      :errors="errors"
      :required="false"
      error-key="subject.email"
      for-id="patient-email"
      label="Email">
      <input
        id="patient-email"
        type="text"
        class="form-control"
        :value="subject.email"
        @input="cleanEmail" />
    </form-group>

    <el-dialog
      title="Error"
      width="60%"
      :before-close="handleCloseRutError"
      custom-class="medication-request-form__dialog responsive-personalizable-css"
      :visible="rutError != ''">
      <div class ="responsive-padding-css" style="word-break: keep-all;">


      {{rutError}}
      </div>

    </el-dialog>

  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import AppRutInput from '@/components/AppRutInput';
import rutHelper from '@/helpers/rut';
import _get from 'lodash/get';
import AddressInput from '@/components/medication/AddressInput';
import dayjs from 'dayjs';

const requiresLegalRepresentative = function(date) {
  if (!date) return false;
  return dayjs(date, 'YYYY-MM-DD') > dayjs().subtract(18, 'year');
};

export default {
  name: 'MedicationRequestPatientInfo',
  components: {
    AddressInput,
    FormGroup,
    AppRutInput
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      fetchingSubjectInformation: false,
      fetchingContactSubjectInformation: false,
      lastSearch: null,
      lastContactSearch: null,
      rutError : '',
      rutErrorContact : false,
      subject: JSON.parse(JSON.stringify(this.value))
    };
  },
  computed: {
    requiresLegalRepresentative() {
      return requiresLegalRepresentative(this.subject.birthDate);
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.subject)) {
          this.subject = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },
  methods: {
    cleanEmail(){
      document.getElementById('patient-email').value = document.getElementById('patient-email').value.replace(/[^a-zA-Z0-9@._-]/g, "");
      this.$emit('input', 'email', document.getElementById('patient-email').value);
    },
    handlePatientUpdate(field, event) {

      const value = _get(event, 'target.value', event);
      this.$emit('input', field, value);
    },
    clearUser() {
      this.handlePatientUpdate('name.given', '');
      this.handlePatientUpdate('name.family', '');
      this.handlePatientUpdate('id', '');
      this.handlePatientUpdate('birthDate', null);
      this.clearUserContact();
    },
    clearUserContact() {
      this.handlePatientUpdate('contact[0]', { id: '', birthDate: null, relationship: [], name: { family: '', given: '' } });
    },
    handleContactIdInputBlur() {

      if (!rutHelper.validate(this.subject.contact[0].id)) {
        this.rutErrorContact = true;
        this.rutError = 'El Run Ingresado es inválido';
        this.clearUserContact();
        return;
      }

     // if (this.subject.contact[0].id === this.lastContactSearch) return;
      this.lastContactSearch = this.subject.contact[0].id;

      this.fetchingContactSubjectInformation = true;
      this.$store.dispatch('fetchSubjectInformation', this.subject.contact[0].id)
        .then(subjectInformation => {
          const birthDate = _get(subjectInformation, 'birthDate');
          if (requiresLegalRepresentative(birthDate)) {
            this.$message({
              message: 'El representante legal debe ser mayor de 18 años.',
              type: 'error'
            });
            return;
          }

          if (_get(subjectInformation, 'name[0].given.0', '') == null &&
            _get(subjectInformation, 'name[0].given.1', '') == null &&
            _get(subjectInformation, 'name[0].given.2', '') == null){
              this.rutErrorContact = false;
              this.rutError = 'No se ha detectado información para el representante legal del paciente.';
              this.clearUserContact();
              return;
          }

          const givenName = _get(subjectInformation, 'name[0].given.0', '').trim();
          const familyName = _get(subjectInformation, 'name[0].given.1', '').trim() + ' ' + _get(subjectInformation, 'name[0].given.2', '').trim();
          this.handlePatientUpdate('contact[0].relationship', [{ 'system': 'http://hl7.org/fhir/ValueSet/patient-contactrelationship', 'code': 'N', 'display': 'Next-of-Kin' }]);
          this.handlePatientUpdate('contact[0].display', `${givenName} ${familyName}`);
          this.handlePatientUpdate('contact[0].reference', subjectInformation.reference);
          this.handlePatientUpdate('contact[0].name.given', givenName);
          this.handlePatientUpdate('contact[0].name.family', familyName);
          this.handlePatientUpdate('contact[0].birthDate', birthDate);
        })
        .catch(e => {
          this.rutErrorContact = true;
          this.rutError = _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del representante legal del paciente.');
          /*
          this.$message({
            message: _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del representante legal del paciente.'),
            type: 'error'
          });
          */
          this.clearUserContact();
        })
        .finally(() => {
          this.fetchingContactSubjectInformation = false;
        });
    },
    handlePatientIdInputBlur() {

      if (!rutHelper.validate(this.subject.id)) {
        this.rutErrorContact = true;
        this.rutError = 'El Run Ingresado es inválido';
        this.clearUser();
        return;
      }

    //  if (this.subject.id === this.lastSearch) return;
      this.lastSearch = this.subject.id;

      this.fetchingSubjectInformation = true;
      this.$store.dispatch('fetchSubjectInformation', this.subject.id)
        .then(subjectInformation => {
          const isDeceased = subjectInformation.deceasedBoolean;
          if (isDeceased) throw new Error(100);

          if (_get(subjectInformation, 'name[0].given.0', '') == null &&
          _get(subjectInformation, 'name[0].given.1', '') == null &&
          _get(subjectInformation, 'name[0].given.2', '') == null){
            this.rutErrorContact = false;
            this.rutError = 'No se ha detectado información para el paciente ingresado';
            this.clearUser();
            return;
          }

          const givenName = _get(subjectInformation, 'name[0].given.0', '').trim();
          const familyName = _get(subjectInformation, 'name[0].given.1', '').trim() + ' ' + _get(subjectInformation, 'name[0].given.2', '').trim();
          const birthDate = _get(subjectInformation, 'birthDate');

          this.handlePatientUpdate('display', `${givenName} ${familyName}`);
          this.handlePatientUpdate('reference', subjectInformation.reference);
          this.handlePatientUpdate('name.given', givenName);
          this.handlePatientUpdate('name.family', familyName);
          if (subjectInformation.address) {
            this.handlePatientUpdate('address', subjectInformation.address);
          } else {
            this.handlePatientUpdate('address', { text: '', state: '', district: '' });
          }

          if (subjectInformation.email){
            this.handlePatientUpdate('email', subjectInformation.email);
          } else {
            this.handlePatientUpdate('email', '');
          }

          if (subjectInformation.legal_representative){
            this.$nextTick(() => {
              this.handlePatientUpdate('contact[0].id', subjectInformation.legal_representative.claveunica_id);
              this.$nextTick(() => {
                this.handleContactIdInputBlur();
              });
            });
          }

          this.handlePatientUpdate('birthDate', birthDate);
          if (requiresLegalRepresentative(birthDate)) {
            this.handlePatientUpdate('contact[0]', { id: '', birthDate: null, name: { family: '', given: '' } });
          } else {
            this.clearUserContact();
          }
        })
        .catch(e => {
         if (e.message === '100') {
            this.rutErrorContact = true;
            this.rutError = _get(
              e,
              'response.data.message',
              'No está permitido prescribir a personas fallecidas.'
            );
          } else {
            this.rutErrorContact = false;
            this.rutError = _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del paciente.');
            console.log('el error es:', e);
            /*
            this.$message({
              message: _get(e, 'response.data.message', 'Ha ocurrido un error al buscar información del paciente.'),
              type: 'error'
            });
            */
          }
          this.clearUser();
        })
        .finally(() => {
          this.fetchingSubjectInformation = false;
        });
    },
    handleCloseRutError(){
      this.rutError = '';
      if (this.rutErrorContact){
        this.subject.contact[0].id = ''
      }else{
        this.subject.id = '';
      }
    }
  }
};
</script>

<style lang="scss">

.responsive-personalizable-css {
   @media (max-width: 500px){
      width: 80% !important;
    }
}

.responsive-padding-css {
  @media (max-width: 500px){
    padding-left: 10px;
    padding-bottom: 5px;
  }
}


</style>
